<template>
  <div>
    <el-dialog
        :fullscreen="true"
        :visible.sync="dialogVisible"
        width="70%"
        :show-close="false"
        append-to-body
        :before-close="handleClose">
        <div style="top: -30px; position: relative; text-align: right; width: 100%; display: flex; flex-direction: column;">
            <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; width: 100%;">
                <h2 style="top: -25px; position: relative;">{{title}}</h2>
                <div style="text-align: right;">
                    <!--<el-button @click="print" size="small" type="primary" style="width: 100px; height: 30px;">
                        Print
                    </el-button>-->
                    <el-button @click="handleClose" size="small" type="danger" style="width: 100px; height: 30px;">
                        Close
                    </el-button>
                </div>
            </div>
            <!--<iframe 
                @load="onLoadFunc" 
                name="printWindowFrame"
                id="printWindowFrame"
                style="height: 100vh; width: 100%;"
                :src="src">
            </iframe>-->
            <embed @load="onLoadFunc" :src="src+''+(isMobileDevice ? '&mobile_device='+getDeviceId : '')" style="height: 100vh; width: 100%;" />
        </div>
        
    </el-dialog>

  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';

export default {
    props: ['dialogVisible', 'src', 'title'],
    data() {
        return {
            printPdf: false,
        }
    },
    computed: {
        getDeviceId() {
            return this.$store.getters.getDeviceToken
        },
        getPdfPath() {
            return this.master_server_url+'temp/'+this.$store.getters.getAccessToken+'.pdf'
        },
        isMobileDevice() {
            return this.getDeviceId !== null || isMobile
        }
    },
    methods: {
        handleClose() {
            this.$emit('closePrintWindow')
        },
        onLoadFunc() {
            this.printPdf = true
            this.$message.closeAll()
        },
        print() {
            printJS({printable: this.master_server_url+'temp/'+this.$store.getters.getAccessToken+'.pdf', type:'pdf', showModal:true})
        }
    },
    mounted() {
        this.$message({
            type: 'warning',
            message: 'Please wait while loading...',
            duration: 0
        });
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/PrintWindow.vue